import { Box, TagColor as Color, Tag } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface BillableTagProps {
  isBillable: boolean
}

export const getBillableLabel = (isBillable: boolean): string => {
  if (isBillable) {
    return i18n.t('project_management.projects.is_billable.billable')
  } else {
    return i18n.t('project_management.projects.is_billable.non_billable')
  }
}

const BillableTag = ({ isBillable }: BillableTagProps) => {
  return (
    <Tag inline capitalize type={Color.grey}>
      <Box style={{ whiteSpace: 'nowrap', overflow: 'hidden' }}>{getBillableLabel(isBillable)}</Box>
    </Tag>
  )
}

export default BillableTag
